/**
 * JWT 토큰 디코딩 유틸리티
 * - JWT 토큰의 payload를 디코딩하여 반환
 * - Base64 URL 디코딩 후 JSON 파싱
 *
 * @param {string} token - JWT 토큰 문자열
 * @returns {Object|null} 디코딩된 payload 객체 또는 null (실패 시)
 */
function decodeJwt(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }

  try {
    // JWT는 header.payload.signature 형태로 구성됨
    const parts = token.split('.');

    if (parts.length !== 3) {
      return null;
    }

    // payload 부분 추출 (두 번째 부분)
    const base64Url = parts[1];

    // Base64 URL을 일반 Base64로 변환
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    // Base64 디코딩
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    );

    // JSON 파싱
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('[decodeJwt] JWT 디코딩 실패', error);
    return null;
  }
}

export default decodeJwt;
